function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.5,
  width: 28,
  height: 28,
  rx: 4,
  fill: "#252CA0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_15376_421299)"
}, React.createElement("path", {
  d: "M14.2723 21.3394H13.3482L9.27641 20.5564L5.45144 21.3394H4.52734V23.9997H14.2723V21.3394Z",
  fill: "#0F0B6A"
}), React.createElement("path", {
  d: "M5.44922 18.6514H13.346V21.3396H5.44922V18.6514Z",
  fill: "#FFC600"
}), React.createElement("path", {
  d: "M13.2228 12.7862C13.4186 13.2272 13.3227 13.7433 12.9815 14.0845L11.8031 15.2628C11.3475 15.7184 10.6088 15.7184 10.1532 15.2628L7.32496 12.4346C6.86935 11.9789 6.86935 11.2403 7.32496 10.7846L8.63379 9.47581C8.87446 9.23514 9.26466 9.23514 9.50533 9.47581C9.56943 9.53991 9.64688 9.58908 9.73216 9.61981L11.7458 10.3455C12.0451 10.4534 12.2874 10.6789 12.4165 10.9697L13.2228 12.7862Z",
  fill: "url(#paint0_linear_15376_421299)"
}), React.createElement("path", {
  d: "M17.7618 7.65299C18.2174 8.1086 18.2174 8.84729 17.7618 9.3029L16.658 10.4067C16.281 10.7837 15.6964 10.8571 15.2378 10.5851L13.7301 9.6906C13.557 9.58788 13.4134 9.44211 13.3133 9.26746L12.1162 7.17931C12.087 7.12827 12.0511 7.08134 12.0095 7.03975C11.7497 6.77994 11.7497 6.3587 12.0095 6.09888L13.2837 4.82472C13.7393 4.36911 14.478 4.36911 14.9336 4.82472L17.7618 7.65299Z",
  fill: "url(#paint1_linear_15376_421299)"
}), React.createElement("path", {
  d: "M15.4274 12.9282L13.0135 12.985L9.60156 9.57307L10.8367 8.33789L13.5466 10.0153L15.4274 12.9282Z",
  fill: "#8C85F4"
}), React.createElement("path", {
  d: "M15.4834 10.514V12.9267L15.4266 12.9279L10.8359 8.33762L12.0715 7.10205L15.4834 10.514Z",
  fill: "#A19AFF"
}), React.createElement("path", {
  d: "M23.2341 20.7327L21.9986 21.9683L13.0156 12.9849L14.2508 11.7498L18.9861 15.3036L23.2341 20.7327Z",
  fill: "#6E67D6"
}), React.createElement("path", {
  d: "M24.4685 19.4975L23.2333 20.7327L14.25 11.7497L15.4856 10.5142L24.4685 19.4975Z",
  fill: "#8D86F5"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_15376_421299",
  x1: 13.6891,
  y1: 9.04004,
  x2: 5.23951,
  y2: 13.9324,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EA4AC7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B960CC"
})), React.createElement("linearGradient", {
  id: "paint1_linear_15376_421299",
  x1: 18.7281,
  y1: 3.99976,
  x2: 10.2785,
  y2: 8.89204,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EA4AC7"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#B960CC"
})), React.createElement("clipPath", {
  id: "clip0_15376_421299"
}, React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(4.5 4)"
})));

var SvgDatlenhActive = function SvgDatlenhActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDatlenhActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/datlenh_active.c49a87b0.svg";
export { ForwardRef as ReactComponent };